import {useContext, useEffect} from "react";
import {AppContext} from "../App";

function Toast() {
    const duration = 10;

    const {toastIsOpen, toastMessage, toastType, setToastIsOpen} = useContext(AppContext);

    useEffect(() => {
        setTimeout(() => {
            setToastIsOpen(false);
        }, duration * 1000);
    });

    const icons = {
        error: <div
            className="inline-flex items-center justify-center shrink-0 w-8 h-8 text-red-500 bg-red-100 rounded-lg">
            <svg className="w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
                 viewBox="0 0 20 20">
                <path
                    d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 11.793a1 1 0 1 1-1.414 1.414L10 11.414l-2.293 2.293a1 1 0 0 1-1.414-1.414L8.586 10 6.293 7.707a1 1 0 0 1 1.414-1.414L10 8.586l2.293-2.293a1 1 0 0 1 1.414 1.414L11.414 10l2.293 2.293Z"/>
            </svg>
            <span className="sr-only">Icône erreur</span>
        </div>,
        sent: <div
            className="inline-flex items-center justify-center shrink-0 w-8 h-8 text-primary bg-primary-100 rounded-lg">
            <svg className="w-5 h-5 rotate-45 " aria-hidden="true"
                 xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 20">
                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                      d="m9 17 8 2L9 1 1 19l8-2Zm0 0V9"/>
            </svg>
            <span className="sr-only">Icône envoyé</span>
        </div>,
        check: <div
            className="inline-flex items-center justify-center shrink-0 w-8 h-8 text-green-500 bg-green-100 rounded-lg">
            <svg className="w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
                 viewBox="0 0 20 20">
                <path
                    d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z"/>
            </svg>
            <span className="sr-only">Icône vu</span>
        </div>,
        warning: <div className="inline-flex items-center justify-center shrink-0 w-8 h-8 text-orange-500 bg-orange-100 rounded-lg">
            <svg className="w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM10 15a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm1-4a1 1 0 0 1-2 0V6a1 1 0 0 1 2 0v5Z"/>
            </svg>
            <span className="sr-only">Icône attention</span>
        </div>
    }

    if (!toastIsOpen){
        return (<></>);
    }

    return (
        <div id="toast"
             className="flex items-center w-full max-w-xs md:max-w-sm p-4 mb-4 text-primary bg-white rounded-lg shadow-lg
             fixed z-50 top-28 md:top-44 right-0 md:right-2"
             role="alert">
            {icons[toastType]}
            <div className="ms-3 text-sm font-normal">{toastMessage}</div>
            <button type="button" onClick={() => {setToastIsOpen(false)}}
                    className="ms-auto -mx-1.5 -my-1.5 bg-white text-primary-light hover:text-primary rounded-lg
                    focus:ring-2 focus:ring-gray-300 p-1.5 hover:bg-gray-100 inline-flex items-center justify-center h-8 w-8"
                    data-dismiss-target="#toast" aria-label="Fermer">
                <span className="sr-only">Fermer</span>
                <svg className="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
                     viewBox="0 0 14 14">
                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                          d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
                </svg>
            </button>
        </div>
    );
}

export default Toast;